<div class="keys-page">
  <div class="keys-header">
    <div>
      <h1>API keys</h1>
      <p>Machine credentials for this company's integrations. Secrets are shown only once.</p>
    </div>
    <button mat-flat-button class="btn-submit" (click)="openCreateDialog()">
      <mat-icon>add</mat-icon>
      New API key
    </button>
  </div>

  <div class="table-toolbar">
    <div class="count-card count-card--blue">
      <div class="count-card__icon"><span class="material-icons">vpn_key</span></div>
      <div class="count-card__text">
        <span class="count-card__main"><strong>{{ totalCount }}</strong> API keys</span>
        <span class="count-card__status">{{ statusFilterLabel }}</span>
      </div>
    </div>

    <app-filter-select
      [(ngModel)]="statusFilter"
      name="statusFilter"
      (ngModelChange)="onFilterChange()"
      [options]="statusOptions"
      allLabel="All statuses"
    />
  </div>

  <app-error-banner [message]="errorMessage()" />

  @if (isLoading()) {
    <p class="hint">Loading...</p>
  } @else if (filteredApiKeys.length === 0) {
    <app-empty-state message="No API keys match this filter." />
  } @else {
    <table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Key</th>
          <th>Status</th>
          <th>Expires</th>
          <th>Last used</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (key of pagedApiKeys; track key.id) {
          <tr>
            <td>{{ key.name }}</td>
            <td><code>{{ key.keyPrefix }}...</code></td>
            <td><app-status-badge [status]="statusOf(key)" /></td>
            <td>{{ key.expiresAt ? (key.expiresAt | date: 'medium') : 'Never' }}</td>
            <td>{{ key.lastUsedAt ? (key.lastUsedAt | date: 'medium') : 'Never' }}</td>
            <td>
              @if (key.active) {
                <button
                  class="remove-btn"
                  (click)="confirmRevokeDialog(key)"
                  [disabled]="revokingId() === key.id"
                  aria-label="Revoke API key"
                  title="Revoke API key"
                >
                  <svg class="bin-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <g class="bin-icon__lid">
                      <line x1="4" y1="7" x2="20" y2="7" />
                      <path d="M10 7V4.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1V7" />
                    </g>
                    <path d="M6 7l1 13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-13" />
                    <line x1="10" y1="11" x2="10" y2="17" />
                    <line x1="14" y1="11" x2="14" y2="17" />
                  </svg>
                </button>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>

    <div class="pagination">
      <div class="page-size-control">
        <span>Results per page</span>
        <app-page-size-select [sizes]="pageSizeOptions" [ngModel]="pageSize()" (ngModelChange)="onPageSizeChange($event)" name="pageSize" />
      </div>

      <div class="pagination-pill">
        <button class="page-nav" (click)="goToPage(page() - 1)" [disabled]="page() === 0">
          <span class="material-icons">chevron_left</span>
          Previous
        </button>
        @for (p of pageWindow; track $index) {
          @if (p === -1) {
            <span class="page-ellipsis">…</span>
          } @else {
            <button class="page-dot" [class.page-dot--active]="p === page()" (click)="goToPage(p)">
              {{ p + 1 }}
            </button>
          }
        }
        <button class="page-nav" (click)="goToPage(page() + 1)" [disabled]="page() === totalPages - 1">
          Next
          <span class="material-icons">chevron_right</span>
        </button>
        <span class="pagination-divider"></span>
        <span class="pagination-summary">Showing {{ rangeStart }}–{{ rangeEnd }} of {{ totalCount }} API keys</span>
      </div>
    </div>
  }
</div>
